import React, {
  forwardRef,
  useEffect,
  useRef,
  memo
} from 'react';

import UserTreeSelect from '../common/UserSelect/UserTreeSelect.jsx';
import VirtualSelectMenuList from '../common/VirtualSelectMenuList.jsx';

// backspace starts the editor on Windows
const KEY_BACKSPACE = 'Backspace';

const UserSelectCellEditor = memo(forwardRef(({column, value, onValueChange, stopEditing, eventKey, options, creatable, addCreatableOption, creatableOptions, ...rest}, ref) => {
  const styles = {
    container: (provided, state) => ({
      ...provided,
      width: column.actualWidth,
      minHeight: 30,
      boxShadow: "inset 0px 0px 4px rgb(0 0 0 / 15%)",
    }),
    control: (provided, state) => ({
      ...provided,
      height: 40,
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "flex-start"
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: "#47a9a666",
      borderRadius: "3px",
      ":hover": {
        backgroundColor: "#47a9a6b3",
      },
      height: 30,
      alignItems: "center"
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: "#47a9a6b3",
      },
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      margin: 0,
      height: 40
    }),
    valueContainer: (provided, state) =>({
      ...provided,
      alignItems: "center",
      height:40,
      flexWrap: "nowrap"
    }),
    indicatorsContainer: (provided, state)=>({
      ...provided,
      height: 40
    }),
    option: (base) => ({
      ...base,
      width: 350,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    menu: (base) => ({
      ...base,
      width: 'auto',
      minWidth: '100%',
      maxWidth: 400,
    }),
  }

  const refContainer = useRef(null);

  const isLeftOrRight = (eventKey) => {
    return ['ArrowLeft', 'ArrowRight'].indexOf(eventKey) > -1;
  };

  const isCharNumeric = (charStr) => {
    return !!/\d/.test(charStr);
  };

  const isNumericKey = (eventKey) => {
    return isCharNumeric(eventKey);
  };

  const isBackspace = (eventKey) => {
    return eventKey === KEY_BACKSPACE;
  };

  useEffect(() => {
    let startValue;

    if (isBackspace(eventKey) || isLeftOrRight(eventKey)) {
      startValue = '';
    } else {
      startValue = value;
    }

    if (startValue == null) {
      startValue = '';
    }

    if (!isNumericKey(eventKey)) {
      onValueChange(startValue);
    }

    refContainer.current.focus();
  }, []);

  const handleChange = (val) => {
    onValueChange(val);
    stopEditing?.();
  };

  return (
  <div ref={refContainer}>
    <UserTreeSelect 
      truncateOptions={true}
      selectComponents={{ MenuList: VirtualSelectMenuList }}
      creatable={creatable}
      value={value} 
      onChange={(val) => handleChange(val)}
      styles={styles} 
      closeMenuOnSelect = {true}
      placeholder={I18n.t('select')}
      autoFocus
      openMenuOnFocus
      {...rest}
    />
  </div>)
}));


export default UserSelectCellEditor;